import apiClient from '@/api.ts';
import { DEVICE_ROOT_API_URL } from '@/routes/device/constants.ts';

export function checkGpsLockByDeviceId(deviceId: number) {
	return apiClient.get(`${DEVICE_ROOT_API_URL}/${deviceId}/gps-lock`);
}
